import React from "react";
import {
  Text,
  TextField,
  Group,
  TextInput,
  Checkbox,
  Button,
  Card,
} from "@mantine/core";
import { useForceUpdate } from "@mantine/hooks";
import RemoteSelect2 from "./remoteSelect2";
import { FormSectionCard } from "../layout/page";
import { useTranslation } from "react-i18next";

const ProviderLoginInfoRow = ({ item, form, name, readOnly = false }) => {
  const forceUpdate = useForceUpdate();
  const { t } = useTranslation();

  return (
    <FormSectionCard>
      <Group grow>
        <RemoteSelect2
          apiEntity="provider"
          label={t("Provider")}
          value={item.content["provider"]}
          searchFields={["name", "code", "shortName"]}
          labelRender={(item) =>
            `[${item.code}] ${item.shortname ?? item.name}`
          }
          onDataChange={(data) => {
            if (readOnly) return;
            item.content["provider"] = data._id;
          }}
          pageSize={1000}
          sort={{ by: "name", order: "asc" }}
          disabled={readOnly}
        />
        <TextInput
          placeholder="http://www.aia.com.hk"
          label={t("Url Address")}
          value={item.content["url"]}
          miw={400}
          readOnly={readOnly}
          onChange={(e) => {
            if (readOnly) return;
            item.content["url"] = e.target.value;
            forceUpdate();
          }}
        />
      </Group>
      <Group grow mt="md">
        <TextInput
          placeholder={t("Username")}
          label={t("Login Name / Email")}
          value={item.content["username"]}
          readOnly={readOnly}
          onChange={(e) => {
            if (readOnly) return;
            item.content["username"] = e.target.value;
            forceUpdate();
          }}
        />
        <TextInput
          placeholder={t("Password")}
          label={t("Password")}
          value={item.content["password"]}
          readOnly={readOnly}
          onChange={(e) => {
            if (readOnly) return;
            item.content["password"] = e.target.value;
            forceUpdate();
          }}
        />
      </Group>
    </FormSectionCard>
  );
};

export default ProviderLoginInfoRow;
